export default __webpack_public_path__ + "static/media/type_14_5.6e771356.svg";